import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerSections = [
    {
      title: 'Useful Links',
      links: ['About Us', 'Services', 'What We Do', 'Careers']
    },
    {
      title: 'Useful Links',
      links: ['About Us', 'Services', 'What We Do', 'Careers']
    },
    {
      title: 'Useful Links',
      links: ['About Us', 'Services', 'What We Do', 'Careers']
    }
  ];

  return (
    <footer className="gradient-bg text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-4"
          >
            <h3 className="text-2xl font-bold">Creativa</h3>
            <p className="text-blue-200 text-sm leading-relaxed">
              This is Photoshop's version of Lorem Ipsum. Proin gravida nibh vel velit auctor aliquet.
            </p>
          </motion.div>

          {/* Footer Links */}
          {footerSections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="space-y-4"
            >
              <h4 className="text-lg font-semibold">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link}>
                    <a 
                      href="#" 
                      className="text-blue-200 hover:text-white text-sm transition-colors"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* Copyright */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="border-t border-blue-700 pt-8 text-center text-sm text-blue-200"
        >
          <p>
            Copyright © {currentYear} Creativa. All rights reserved. | 
            <span className="ml-1">
              Domain + Hosting + Design = 
              <a 
                href="https://account4web.ca" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-orange-400 hover:text-orange-300 font-medium ml-1"
              >
                Account4Web Inc
              </a>
            </span>
          </p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;